import styled from 'styled-components';
import { Box, Text, Button } from '@rsos/components/capstone/base';

export const ShareButton = styled(Button).attrs({
  btnType: 'invisible',
  size: 'xxsmall',
  margin: '0 3px 0 0',
})`
  padding: 3px;
`;

export const ShareTooltipContainer = styled(Box).attrs({
  backgroundColor: 'primaryText',
  padding: '10px',
  borderRadius: '5px',
  maxWidth: '250px',
})``;

export const ShareTooltipText = styled(Text).attrs({
  size: 'small',
  color: 'background',
})``;
